import { memo, useEffect } from "react";
import { Badge, Collapse } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import Menu from "../../Menu.js";
import { setCollapse } from "../../store/sidebar";
import { toast } from "react-toastify";

function Sidebar() {
  let location = useLocation();
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const collapse = useSelector((state) => state?.sidebarReducer?.collapse);
  const userType = localStorage.getItem("permissions")?.split(',') || [];
  const userData = JSON.parse(localStorage.getItem("user") || "{}");
  const isAdmin = userData?.adminOfHubs;
  const permissionOfHub = userData?.user?.permissionOfHub;
  const permissions = localStorage.getItem("permissions")?.split(',') || [];
  const hubId = localStorage.getItem("hubId");
  
 
  useEffect(() => {
    if (!hubId && !permissionOfHub && permissions.length === 0) {
      // console.log("navigate login for all empty")
      toast.error("You do not have access to this portal.");
      navigate("/", { replace: true });
    }
  }, [hubId, permissionOfHub, permissions, navigate]);
  
  useEffect(() => {
    let newcollapse = JSON.parse(JSON.stringify(collapse));
    let hasChanges = false;

    Menu.filter(({ heading }) => !heading).forEach(
      ({ name, path, submenu }) => {
        const isActive = routeActive(
          submenu ? submenu.map(({ path }) => path) : path
        );
        if (newcollapse[name] !== isActive) {
          newcollapse[name] = isActive;
          hasChanges = true;
        }
      }
    );

    if (hasChanges) {
      dispatch(setCollapse(newcollapse));
    }
  }, [location.pathname]); 



 const filteredMenu = Menu.filter(item => {
    if (isAdmin) return true;
    if (permissionOfHub) {
      const hideItems = ['Dashboard', 'View Community'];
      return !hideItems.includes(item.title);
    }
    if (permissions.length > 0) {
      if (!item.permissions) return false;
      return permissions.some(permission => item.permissions.includes(permission));
    }
    return false; 
  });


if (hubId && permissionOfHub && permissions.length > 0) {
  Navigate("/")
  return (
    <div style={{ color: 'red', textAlign: 'center', marginTop: '20px' }}>
      You do not have access to this portal.
    </div>
  );
}

  const SidebarItemHeader = ({ item }) => {
    return (
      <li className="nav-heading">
        <span>{item.heading}</span>
      </li>
    );
  };
  
  const SidebarItem = ({ item, isActive }) => {
    return (
      <li className={isActive ? "active" : ""}>
        <Link to={item.path} title={item.name}>
          {item.label && (
            <Badge tag="div" className="float-right" color={item.label.color}>
              {item.label.value}
            </Badge>
          )}
          {item.icon && <em className={item.icon}></em>}
          <span>{item.name}</span>
        </Link>
      </li>
    );
  };

  const SidebarSubItem = ({ item, isActive, handler, children, isOpen }) => {

    return (
      <li className={isActive ? "active" : ""}>
        <div className="nav-item" onClick={handler}>
          {item.label && (
            <Badge tag="div" className="float-right" color={item.label.color}>
              {item.label.value}
            </Badge>
          )}
          {item.icon && <em className={item.icon}></em>}
          <span>{item.name}</span>
        </div>

        <Collapse>
          <ul
            id={item.path}
            className={`sidebar-nav sidebar-subnav ${isOpen ? "show" : ""}`}
          >
            {children}
          </ul>
        </Collapse>
      </li>
    );
  };

  const SidebarSubHeader = ({ item }) => {
    return <li className="sidebar-subnav-header"><span>{item.name}</span></li>;
  };

  const itemType = (item) => {
    if (item.heading) return "heading";
    if (!item.submenu) return "menu";
    if (item.submenu) return "submenu";
  };

  const routeActive = (paths) => {
    paths = Array.isArray(paths) ? paths : [paths];
    return paths.some((p) => location.pathname.indexOf(p) > -1);
  };

  const toggleItemCollapse = (stateName) => {
    let newcollapse = JSON.parse(JSON.stringify(collapse));
    for (let c in newcollapse) {
      if (newcollapse[c] === true && c !== stateName) {
        newcollapse[c] = false;
      }
    }

    newcollapse[stateName] = !newcollapse[stateName];
    dispatch(setCollapse(newcollapse));
  };

  const getSubRoutes = (item) => item.submenu.map(({ path }) => path);

  return (
    <>
      <aside className="aside-container">
        <div className="aside-inner">
          <nav data-sidebar-anyclick-close="" className="sidebar">
            <ul className="sidebar-nav">
              <li className="has-user-block">
              </li>

              {filteredMenu.map((item, i) => {
                if (itemType(item) === "heading")
                  return <SidebarItemHeader item={item} key={i} />;
                else {
                  if (itemType(item) === "menu")
                    return (
                      <SidebarItem
                        isActive={routeActive(item.path)}
                        item={item}
                        key={i}
                      />
                    );
                  if (itemType(item) === "submenu")
                    return [
                      <SidebarSubItem
                        item={item}
                        isOpen={collapse[item.name]}
                        handler={() => toggleItemCollapse(item.name)}
                        isActive={routeActive(getSubRoutes(item))}
                        key={i}
                      >
                        <SidebarSubHeader item={item} key={i} />
                        {item.submenu.map((subitem, i) => (
                          <SidebarItem
                            key={i}
                            item={subitem}
                            isActive={routeActive(subitem.path)}
                          />
                        ))}
                      </SidebarSubItem>,
                    ];
                }
                return null;
              })}
            </ul>
          </nav>
        </div>
      </aside>
    </>
  );
}

export default memo(Sidebar);
